@defer (on idle) {
  <app-side-nav></app-side-nav>
  <app-header></app-header>
}
<div class="relative h-max">
  <app-particles-background *ngIf="playBubbleAnime" class="absolute h-full w-full"></app-particles-background>
  <div class="md:pl-[18.75rem] md:pb-0 relative transition-all duration-500 ease">
    <router-outlet></router-outlet>
    @defer (on idle) {
      <app-footer
        *ngIf="
          (isActiveGame && !isMobile && !isSportBook && !isNotFoundPage) ||
          (!isSportBook && !isActiveGame && !isNotFoundPage)
        "></app-footer>
    }
  </div>
</div>
@defer (on idle) {
  <div *transloco="let t">
    <!-- video about loyalty on mobile, not logged in user || is logged in loyalty page and is mobile-->
    <!-- <div
      *ngIf="(isMobile && !isAuth) || (isAuth && isLoyaltyPage && isMobile)"
      [class]="
        'fixed bg-darkBlueBgLight cursor-pointer group right-4 w-[3.813rem] px-3 h-12 rounded-xl z-[8]' +
        (userRestricted ? ' bottom-28 ' : ' bottom-20 ')
      "
      id="watchVideo"
      (click)="openModal()">
      <div class="flex items-center justify-center h-full">
        <img
          class="w-[1.375rem] h-[1.375rem] justify-self-end"
          src="https://cdn.chipychapa.com//welle/Video/Loyalty_page/play_mob.svg"
          alt="" />
      </div>
    </div>

      video about loyalty on desktop, not logged in user || is logged in and in loyalty page  
    <div
      *ngIf="(!isMobile && !isAuth) || (isAuth && isLoyaltyPage && !isMobile)"
      class="fixed bg-tooltipLight cursor-pointer group right-[7.5rem] bottom-10 w-[22.938rem] rounded-[0.625rem] z-[8]"
      id="watchVideo">
      <div
        class="flex items-center h-full"
        (click)="toggleAccordion()"
        (mouseenter)="!isMobile ? (isHovering = true) : ''"
        (mouseleave)="!isMobile ? (isHovering = false) : ''">
        <div class="grid grid-cols-[1fr,25%,7%] items-center w-full gap-1 px-3 py-[0.56rem]">
          <p class="font-semibold text-sm text-white">{{ t('notifications.loyalty.learnMore') }}</p>
          <p
            *ngIf="!isAcordionOpen"
            [class]="
              'transition-all font-medium text-xs text-right' +
              (isHovering ? ' text-white underline ' : ' text-mainBtnLight ')
            ">
            {{ t('notifications.loyalty.watch') }}
          </p>
          <img
            [class]="
              'justify-self-end col-start-3 transition-all' +
              (!isAcordionOpen || (!isAcordionOpen && isHovering) ? ' w-[1.375rem] h-[1.375rem] ' : ' w-4 h-4 ')
            "
            [src]="
              isAcordionOpen
                ? 'https://cdn.chipychapa.com//welle/Video/Loyalty_page/close.svg'
                : !isAcordionOpen && isHovering
                  ? 'https://cdn.chipychapa.com//welle/Video/Loyalty_page/play_mob_whitr.svg'
                  : 'https://cdn.chipychapa.com//welle/Video/Loyalty_page/play_mob.svg'
            " />
        </div>
      </div>
      <div
        [class]="
          (isAcordionOpen ? 'max-h-[44rem] px-3 py-4' : 'max-h-0') +
          ' w-[22.938rem] rounded-b-[0.625rem] accordionShadow bg-biggerContainerBgLight overflow-hidden z-[7] relative flex items-center justify-center transition-all ease-in-out duration-500 flex-col gap-2'
        ">
        <div
          [class]="
            'w-[20.875rem] h-[11.75rem] rounded-[0.688rem] bg-smallContainerBgLight' +
            (!isLoaded ? ' animate-pulse ' : '')
          ">
          <div style="position: relative; padding-top: 56.25%">
            <iframe
              id="loyaltyVideo"
              [src]="videoUrl"
              loading="lazy"
              style="border: none; border-radius: 11px; position: absolute; top: 0; left: 0; height: 100%; width: 100%"
              allow="accelerometer; gyroscope; encrypted-media; picture-in-picture;"
              allowfullscreen="true"></iframe>
          </div>
        </div>
      </div>
    </div> -->
  </div>

  <!-- live chat on desktop -->
  <div
    *ngIf="!isMobile"
    (click)="openLiveChat()"
    class="fixed cursor-pointer group right-6 bottom-6 p-4 rounded-full z-[101]"
    id="liveSupport">
    <img class="group-hover:scale-110" ngSrc="supportCorner" width="67" height="57" alt="support" id="liveSupport" />
  </div>

  <!-- backtotop on desktop -->
  <div
    *ngIf="showBackTop && !isMobile"
    [@btnTrigger]
    (click)="navigateTop()"
    (scroll)="onBackScroll($event)"
    class="btn fixed z-[2] top-1/2 right-0 cursor-pointer h-10 font-bold text-[#0C4A6E] dark:text-mainText text-sm rounded-t-md bg-lineLight hover:bg-mainBgLight dark:bg-mainHover/75 px-4 pb-3 pt-3 opacity-50 hover:opacity-100 hover:text-white flex items-center space-x-2 transform -translate-y-full -rotate-90 origin-bottom-right box-shadow gap-[0.625rem]"
    id="backToTop">
    <span>
      {{ 'buttons.to_top_button' | transloco }}
    </span>
    <img class="rotate-90 filter-svg" width="10" height="10" ngSrc="leftArrow" alt="leftArrow" />
  </div>
  <app-global-notification></app-global-notification>
}
